// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgs_a bhy_vt bhy_ea bhy_a","MenuItem__Btn":"bgs_b bhy_z","MenuItem__subtitle":"bgs_c"};